import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { NavArrowLeft } from 'iconoir-react';

export const PricingHeader: React.FC = () => {
  const navigate = useNavigate();

  return (
    <header className="landing-header">
      <div className="landing-container">
        <div className="landing-nav">
          <Link to="/" className="landing-logo">
            <img src="/assets/ventilio.png" alt="Ventilio" className="landing-logo-img" />
          </Link>
          <button type="button" className="btn-landing-secondary contact-back-btn" onClick={() => navigate('/')}>
            <NavArrowLeft width={18} height={18} strokeWidth={2} />
            Retour à l'accueil
          </button>
        </div>
      </div>
    </header>
  );
};
